/**
 * © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED
 * Tinder Obsidian v10.18.0
 * Do not edit directly
 * Generated on Fri, 01 Nov 2024 18:19:22 GMT
 */

import {
  ThemeFontFamily,
  ThemeFontSize,
  ThemeFontWeight,
  ThemeLineHeight,
  ThemeLetterSpacing,
  ThemeLetterCasing,
  ThemeType,
} from '../types';

export const FONT_NAME_PROXIMA_NOVA = 'Proxima Nova';
export const FONT_FAMILY_BASE: ThemeFontFamily = "'Helvetica Neue', Arial, Helvetica, sans-serif";
export const FONT_SIZE_0: ThemeFontSize = 12;
export const FONT_SIZE_5: ThemeFontSize = 14;
export const FONT_SIZE_10: ThemeFontSize = 15;
export const FONT_SIZE_20: ThemeFontSize = 17;
export const FONT_SIZE_30: ThemeFontSize = 19;
export const FONT_SIZE_40: ThemeFontSize = 20;
export const FONT_SIZE_45: ThemeFontSize = 24;
export const FONT_SIZE_50: ThemeFontSize = 28;
export const FONT_SIZE_60: ThemeFontSize = 34;
export const FONT_SIZE_BASE: ThemeFontSize = 10;
export const FONT_WEIGHT_LIGHT: ThemeFontWeight = 'light';
export const FONT_WEIGHT_REGULAR: ThemeFontWeight = 'regular';
export const FONT_WEIGHT_MEDIUM: ThemeFontWeight = 'medium';
export const FONT_WEIGHT_SEMIBOLD: ThemeFontWeight = 'semibold';
export const FONT_WEIGHT_BOLD: ThemeFontWeight = 'bold';
export const FONT_WEIGHT_EXTRABOLD: ThemeFontWeight = 'extrabold';
export const LINE_HEIGHT_0: ThemeLineHeight = 16;
export const LINE_HEIGHT_10: ThemeLineHeight = 18;
export const LINE_HEIGHT_20: ThemeLineHeight = 20;
export const LINE_HEIGHT_30: ThemeLineHeight = 22;
export const LINE_HEIGHT_40: ThemeLineHeight = 24;
export const LINE_HEIGHT_50: ThemeLineHeight = 26;
export const LINE_HEIGHT_60: ThemeLineHeight = 36;
export const LINE_HEIGHT_70: ThemeLineHeight = 42;
export const LETTER_SPACING_0: ThemeLetterSpacing = 0;
export const LETTER_SPACING_10: ThemeLetterSpacing = 0.09;
export const LETTER_SPACING_20: ThemeLetterSpacing = 0.12;
export const LETTER_SPACING_30: ThemeLetterSpacing = 0.14;
export const LETTER_CASING_NONE: ThemeLetterCasing = 'none';
export const FONT_FAMILY_PROXIMA_NOVA: ThemeFontFamily = `'${FONT_NAME_PROXIMA_NOVA}', ${FONT_FAMILY_BASE}`;
export const TYPE_STYLE_DISPLAY_1_STRONG: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_BOLD,
  fontSize: FONT_SIZE_60,
  lineHeight: LINE_HEIGHT_70,
  letterSpacing: LETTER_SPACING_30,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_DISPLAY_1_REGULAR: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_REGULAR,
  fontSize: FONT_SIZE_60,
  lineHeight: LINE_HEIGHT_70,
  letterSpacing: LETTER_SPACING_30,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_DISPLAY_2_STRONG: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_BOLD,
  fontSize: FONT_SIZE_50,
  lineHeight: LINE_HEIGHT_60,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_DISPLAY_2_REGULAR: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_REGULAR,
  fontSize: FONT_SIZE_50,
  lineHeight: LINE_HEIGHT_60,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_DISPLAY_3_STRONG: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_BOLD,
  fontSize: FONT_SIZE_40,
  lineHeight: LINE_HEIGHT_40,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_DISPLAY_3_REGULAR: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_MEDIUM,
  fontSize: FONT_SIZE_40,
  lineHeight: LINE_HEIGHT_40,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_DISPLAY_2_SPARKS_STRONG: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_BOLD,
  fontSize: FONT_SIZE_45,
  lineHeight: FONT_SIZE_45,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_DISPLAY_2_SPARKS_REGULAR: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_REGULAR,
  fontSize: FONT_SIZE_45,
  lineHeight: FONT_SIZE_45,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_HEADING_1: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_BOLD,
  fontSize: FONT_SIZE_40,
  lineHeight: LINE_HEIGHT_40,
  letterSpacing: LETTER_SPACING_10,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_SUBHEADING_1: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_BOLD,
  fontSize: FONT_SIZE_20,
  lineHeight: LINE_HEIGHT_30,
  letterSpacing: LETTER_SPACING_30,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_SUBHEADING_2: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_BOLD,
  fontSize: FONT_SIZE_10,
  lineHeight: LINE_HEIGHT_20,
  letterSpacing: LETTER_SPACING_30,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_BODY_1_REGULAR: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_REGULAR,
  fontSize: FONT_SIZE_20,
  lineHeight: LINE_HEIGHT_40,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_BODY_1_STRONG: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_BOLD,
  fontSize: FONT_SIZE_20,
  lineHeight: LINE_HEIGHT_40,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_BODY_1_LINK: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_BOLD,
  fontSize: FONT_SIZE_20,
  lineHeight: LINE_HEIGHT_40,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_BODY_2_REGULAR: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_MEDIUM,
  fontSize: FONT_SIZE_10,
  lineHeight: LINE_HEIGHT_20,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_BODY_2_STRONG: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_BOLD,
  fontSize: FONT_SIZE_10,
  lineHeight: LINE_HEIGHT_20,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_BODY_2_LINK: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_BOLD,
  fontSize: FONT_SIZE_10,
  lineHeight: LINE_HEIGHT_20,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_BODY_3_REGULAR: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_MEDIUM,
  fontSize: FONT_SIZE_5,
  lineHeight: LINE_HEIGHT_10,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_BODY_3_STRONG: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_BOLD,
  fontSize: FONT_SIZE_5,
  lineHeight: LINE_HEIGHT_10,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_BODY_3_LINK: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_BOLD,
  fontSize: FONT_SIZE_5,
  lineHeight: LINE_HEIGHT_10,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_BODY_1_SPARKS_SEMIBOLD: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_SEMIBOLD,
  fontSize: FONT_SIZE_20,
  lineHeight: LINE_HEIGHT_40,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_BODY_2_SPARKS_SEMIBOLD: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_SEMIBOLD,
  fontSize: FONT_SIZE_10,
  lineHeight: LINE_HEIGHT_20,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_CAPTION_1_REGULAR: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_MEDIUM,
  fontSize: FONT_SIZE_0,
  lineHeight: LINE_HEIGHT_0,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_CAPTION_1_STRONG: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_BOLD,
  fontSize: FONT_SIZE_0,
  lineHeight: LINE_HEIGHT_0,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_CAPTION_1_LINK: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_BOLD,
  fontSize: FONT_SIZE_0,
  lineHeight: LINE_HEIGHT_0,
  letterSpacing: LETTER_SPACING_0,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_BUTTON_1: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_BOLD,
  fontSize: FONT_SIZE_30,
  lineHeight: LINE_HEIGHT_50,
  letterSpacing: LETTER_SPACING_30,
  letterCasing: LETTER_CASING_NONE,
};
export const TYPE_STYLE_BUTTON_2: ThemeType = {
  fontFamily: FONT_FAMILY_PROXIMA_NOVA,
  fontWeight: FONT_WEIGHT_BOLD,
  fontSize: FONT_SIZE_10,
  lineHeight: LINE_HEIGHT_20,
  letterSpacing: LETTER_SPACING_20,
  letterCasing: LETTER_CASING_NONE,
};
